import { render, staticRenderFns } from "./ClaimDetailsStep.vue?vue&type=template&id=5b4a0471"
import script from "./ClaimDetailsStep.vue?vue&type=script&lang=js"
export * from "./ClaimDetailsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports